import { motion } from 'framer-motion';
import styled from 'styled-components';

import { device } from 'config/device';

export const SidebarOverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  opacity: 0.7;
  background: black;
`;
export const SidebarContainer = motion(styled.div`
  width: 30rem;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 30;
  background: #ffffff;
  @media ${device.tablet} {
    right: 0;
    left: initial;
    // width: 100vw;
  }
`);

export const SidebarContent = styled.div`
  height: 100%;
  // color: white;
  position: relative;
  padding: 1rem 0;
  padding-left: 3rem;
  display: flex;
  flex-direction: column;
  grid-gap: 0;
  .header {
    padding-right: 3rem;
    font-size: ${(props) => props.theme.medium};
    display: flex;
    align-items: center;
    justify-content: center;
    grid-gap: 1rem;
  }
  .info {
    padding-right: 3rem;
    display: flex;
    flex-direction: column;
    grid-gap: 1rem;
    font-size: ${(props) => props.theme.medium};
  }
  .children {
    height: 100%;
    overflow-y: auto;
    padding-right: 3rem;
    padding-top: 2rem;
  }
  .footer {
    border-top: 1px solid ${(props) => props.theme.grayLight};
    margin-left: -30px;
    padding-left: 3rem;
    padding-top: 10px;
    padding-right: 3rem;
    box-shadow: ${(props) => props.theme.shadow[0]};
  }
`;
